interface SPKSingleEmployerCandidateShowcaseInterface {
  icon: any;
  title: string;
  link?: string;
  onClick?: () => void;
  additionalClassNames?: string;
  segmentEvent?: () => void;
}

const SPKSingleEmployerCandidateShowcase = ({
  link,
  onClick,
  icon,
  title,
  additionalClassNames,
  segmentEvent,
}: SPKSingleEmployerCandidateShowcaseInterface) => {
  if (link && !link?.startsWith('http:') && !link?.startsWith('https:')) {
    link = `//${link}`;
  }

  const onClickHandler = (ev: any) => {
    if (!link || link === '') ev.preventDefault();
    if (onClick) onClick();
    if (segmentEvent) segmentEvent();
  };

  return (
    <div className={additionalClassNames}>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        onClick={onClickHandler}
        className="inline-block"
      >
        <div className="flex flex-row items-start gap-2 text-sm">
          <span className="mt-[2px]">{icon}</span>
          <div className="capitalize text-sm">{title}</div>
        </div>
      </a>
    </div>
  );
};

SPKSingleEmployerCandidateShowcase.defaultProps = {
  link: '',
  onClick: () => {},
  additionalClassNames: '',
  segmentEvent: () => {},
};

export default SPKSingleEmployerCandidateShowcase;
